import React from 'react';
import { Switch } from '@mui/material';
import { styled } from '@mui/system';

const IOSSwitch = styled((props) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(
  ({ theme }) => ({
    width: '38px',
    height: '21px',
    padding: '0px',
    borderRadius: '50px',
    '& .hotglue-w-MuiSwitch-switchBase:hover': {
      backgroundColor: 'initial',
    },
    '& .hotglue-w-MuiSwitch-switchBase .Mui-checked:hover': {
      backgroundColor: 'initial',
    },
    '& .hotglue-w-MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',

        '& + .hotglue-w-MuiSwitch-track': {
          backgroundColor: theme.palette.primary.main,
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .hotglue-w-MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .hotglue-w-MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .hotglue-w-MuiSwitch-thumb': {
        color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600],
      },
      '&.Mui-disabled + .hotglue-w-MuiSwitch-track': {
        opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
      },
    },
    '& .hotglue-w-MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: '16px !important',
      height: '16px !important',
    },
    '& .hotglue-w-MuiSwitch-track': {
      borderRadius: 50,
      backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  })
);

export default IOSSwitch;
